import { OptionalEnumSchema } from 'notable-common';
import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { FlowBlockValueUuidSchema } from '../../blockValue/uuidSchema.js';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowRestRequestBodyFormat, FlowRestResponseBodyFormat, } from '../rest/shared/bodyFormat.js';
import { FlowBlockType } from '../type.js';
export const FlowAdvancedFhirBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.AdvancedFhir),
    config: z.object({
        apiInstanceId: FlowBlockValueUuidSchema({ isRequired: true }),
        path: z.string().refine((path) => path.startsWith('/'), {
            message: 'Path must start with /',
        }),
        selectedResponseHeaders: z.array(z.string()).optional(),
        method: z.enum(['GET', 'POST', 'PUT', 'PATCH', 'DELETE']),
        headers: z
            .array(z.object({
            key: z.string().min(1, {
                message: 'Header key cannot be empty.',
            }),
            value: z.string().min(1, {
                message: 'Header value cannot be empty.',
            }),
        }))
            .optional(),
        params: z
            .array(z.object({
            key: z.string().min(1, {
                message: 'Parameter key cannot be empty.',
            }),
            value: z.string().min(1, {
                message: 'Parameter value cannot be empty.',
            }),
        }))
            .optional(),
        bodyFormat: OptionalEnumSchema(FlowRestRequestBodyFormat, FlowRestRequestBodyFormat.RawJson),
        responseBodyFormat: OptionalEnumSchema(FlowRestResponseBodyFormat, FlowRestResponseBodyFormat.AutoDetect),
        body: z.string().optional(),
        apiInstanceFhirEndpointId: z.string().optional(),
    }),
});
export const FlowConsumerOfAdvancedFhirResponseSchema = z
    .object({
    sourceBlockName: z.string(),
})
    .transform(({ sourceBlockName }) => ({
    sourceBlockName,
    consumesType: FlowProducedType.AdvancedFhirResponse,
}));
//# sourceMappingURL=config.js.map